module.exports = __webpack_public_path__ + "static/media/district.af925b24.svg";